import { useNavigate } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  return (
    <footer role="contentinfo" className="w-full px-4 mt-6 mb-6 relative z-10">
      <div className="max-w-6xl mx-auto">
        

        <div className="rounded-2xl border border-zinc-900 bg-zinc-950/20 backdrop-blur-sm px-5 py-6">
          <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
            
            {/* Branding & Droits */}
            <div className="text-center md:text-left space-y-1">
              <span className="block text-xs uppercase tracking-wider text-zinc-500">
                © {currentYear}{" "}
                <span className="font-bold tracking-tight text-zinc-300">
                  Kettlecore <span className="text-yellow-400/80">Sync</span>™
                </span>
              </span>
              <p className="text-[10px] text-zinc-600 uppercase tracking-widest">Tous droits réservés.</p>
            </div>

            {/* Liens de Navigation Secondaires */}
            <nav aria-label="Liens de pied de page">
              <ul className="flex flex-col items-center gap-1.5 sm:flex-row sm:gap-2">
                {[
                  { label: "À propos", path: "/about" },
                  { label: "Confidentialité", path: "/privacy-policy" },
                  { label: "CGU", path: "/cgu" },
                ].map((link) => (
                  <li key={link.path}>
                    <button
                      onClick={() => navigate(link.path)}
                      className="text-xs font-medium text-zinc-400 hover:text-white px-3 py-1.5 rounded-lg hover:bg-zinc-900/50 border border-transparent hover:border-zinc-800 transition duration-200 focus:outline-none focus-visible:ring-1 focus-visible:ring-yellow-400/30"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </nav>

            {/* Signature & Crédits */}
            <div className="text-center md:text-right">
              <span className="text-xs text-zinc-500 tracking-wide">
                Créé par{" "}
                <a
                  href="https://fvancamp-dev.fr/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-semibold text-zinc-400 hover:text-yellow-400 underline decoration-zinc-800 hover:decoration-yellow-400/40 underline-offset-4 transition duration-200"
                  aria-label="Site de BLF DEVELOPPEMENT (nouvel onglet)"
                >
                  BLF DEVELOPPEMENT
                </a>
              </span>
            </div>

          </div>
        </div>
      </div>
    </footer>
  );
}